/** HTTP Responseを返したいときに使うHTTPエラーの基底となるエラー
 * 直接は使わず、これを継承したエラーを使う
 * @param message エラーメッセージ
 * @param code HTTPステータスコード
 * @param path エラーが発生したHTTPリクエストのパス
 */
export class HTTPError extends Error {
  path: string;
  code: number;
  constructor(message: string, code: number, path: string) {
    super(message);
    this.name = "HTTPError";
    this.code = code;
    this.path = path;
  }
}

export class NotFoundError extends HTTPError {
  constructor(message: string, path: string) {
    super(message, 404, path);
    this.name = "NotFoundError";
  }
}

export class InternalServerError extends HTTPError {
  constructor(message: string, path: string) {
    super(message, 500, path);
    this.name = "InternalServerError";
  }
}

export class BadRequestError extends HTTPError {
  constructor(message: string, path: string) {
    super(message, 400, path);
    this.name = "BadRequestError";
  }
}
